type MobilePlatform = 'ios' | 'android' | null;

/**
 * Real device detection, not viewport width: a narrow desktop window is still a desktop.
 * Prefers `userAgentData` (Chromium), falls back to the UA string, and treats a
 * touch-capable "Macintosh" as an iPad (iPadOS 13+ reports a desktop UA).
 */
export const getMobilePlatform = (): MobilePlatform => {
  if (typeof navigator === 'undefined') {
    return null;
  }

  const uaData = (navigator as any).userAgentData;
  if (uaData && typeof uaData.mobile === 'boolean' && !uaData.mobile) {
    return null;
  }

  const ua = navigator.userAgent || '';

  if (/android/i.test(ua)) {
    return 'android';
  }

  const isIPadOS = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  if (/iPhone|iPad|iPod/i.test(ua) || isIPadOS) {
    return 'ios';
  }

  return null;
};

export const isMobileDevice = (): boolean => getMobilePlatform() !== null;
